import { Component, OnInit, Inject } from "@angular/core";
import {
  FormGroup,
  FormBuilder,
  Validators,
  FormControl,
  FormArray
} from "@angular/forms";
import { MatSelect, MAT_DIALOG_DATA, MatDialogRef } from "@angular/material";

import { IArea } from "src/app/interfaces/area";
import { ICity } from "src/app/interfaces/city";
import { SoundEnum } from "src/app/enums/sound.enum";
import { ICompany } from "src/app/interfaces/company";
import { IHolding } from "src/app/interfaces/holding";
import { TranslateService } from "@ngstack/translate";
import { IProvince } from "src/app/interfaces/province";
import { IPhoneType } from "src/app/interfaces/phoneType";
import { ErrorsService } from "src/app/services/common/errors.service";
import { SnackBarService } from "src/app/services/common/snackBar.service";
import { CityService } from "src/app/services/http/business/city/city.service";
import { AreaService } from "./../../../../services/http/business/area/area.service";
import { CompanyService } from "src/app/services/http/business/company/company.service";
import { PhoneTypeService } from "src/app/services/http/business/phoneType/phone-type.service";
import { ProvinceService } from "./../../../../services/http/business/province/provinces.service";
import { IError } from "src/app/interfaces/error.interface";

@Component({
  selector: "app-company-entry",
  templateUrl: "./company-entry.component.html",
  styleUrls: ["./company-entry.component.css"],
  providers: [ErrorsService]
})
export class CompanyEntryComponent implements OnInit {
  cityList: ICity;
  areaList: IArea;
  CompanyForm: FormGroup;
  holdingList: IHolding[];
  provinceList: IProvince;
  phoneTypeList: IPhoneType;
  errors = new Array();
  errObject: any;
  param: any;
  errorList: IError[] = [];
  constructor(
    private fb: FormBuilder,
    private cityService: CityService,
    private areaService: AreaService,
    private snackBar: SnackBarService,
    private errorService: ErrorsService,
    public translate: TranslateService,
    private companyService: CompanyService,
    private provinceService: ProvinceService,
    private phoneTypeService: PhoneTypeService,
    private dialogRef: MatDialogRef<CompanyEntryComponent>,

    @Inject(MAT_DIALOG_DATA) public data: ICompany
  ) { }

  ngOnInit() {
    this.init();
    this.CompanyForm = this.fb.group({
      CompanyEncryptId: [
        this.data && this.data["CompanyEncryptId"]
          ? this.data["CompanyEncryptId"]
          : ""
      ],
      CompanyName: [
        this.data && this.data["CompanyName"] ? this.data["CompanyName"] : null,
        Validators.compose([
          Validators.required,
          Validators.maxLength(50),
          Validators.minLength(3)
        ])
      ],

      TaxCode: [
        this.data && this.data["TaxCode"] ? this.data["TaxCode"] : null,
        Validators.compose([
          Validators.maxLength(50),
          Validators.pattern("([0-9]{12})")
        ])
      ],

      EconomicNumber: [
        this.data && this.data["EconomicNumber"]
          ? this.data["EconomicNumber"]
          : null,
        Validators.compose([
          Validators.maxLength(50),
          Validators.pattern("([0-9]{11})")
        ])
      ],

      RegistrationNumber: [
        this.data && this.data["RegistrationNumber"]
          ? this.data["RegistrationNumber"]
          : null,
        Validators.compose([Validators.maxLength(50)])
      ],

      AccountCode: [
        this.data && this.data["AccountCode"] ? this.data["AccountCode"] : null,
        Validators.compose([Validators.maxLength(25)])
      ],

      ProvinceId: [
        this.data && this.data["ProvinceId"]
          ? this.data["ProvinceId"].toString()
          : null
      ],



      AddressDto: this.fb.group({
        CityId: [
          this.data &&
            this.data["AddressDto"] &&
            this.data["AddressDto"]["CityId"]
            ? this.data["AddressDto"]["CityId"].toString()
            : null,
          Validators.compose([Validators.required])
        ],

        AreaId: [
          this.data &&
            this.data["AddressDto"] &&
            this.data["AddressDto"]["AreaId"]
            ? this.data["AddressDto"]["AreaId"].toString()
            : null
        ],


        Address: [
          this.data &&
            this.data["AddressDto"] &&
            this.data["AddressDto"]["Address"]
            ? this.data["AddressDto"]["Address"]
            : null,
          Validators.compose([Validators.required, Validators.maxLength(250)])
        ],

        Longitude: [null],

        Latitude: [null],

        PostalCode: [
          this.data &&
            this.data["AddressDto"] &&
            this.data["AddressDto"]["PostalCode"]
            ? this.data["AddressDto"]["PostalCode"]
            : null,
          Validators.compose([Validators.pattern("^[0-9]{10}?$")])
        ]
      }),
      // 'ListPhone': this.fb.array([new FormGroup({
      //   'GuidId': new FormControl(''),
      //   'PhoneNumber': new FormControl(null, Validators.maxLength(11)),
      //   'PhoneType': new FormControl(null,Validators.required )
      // })]),
      // 'ListManager': this.fb.array([new FormGroup({
      //   'GuidId': new FormControl(''),
      //   'FirsName': new FormControl(null, Validators.required),
      //   'LastName': new FormControl(null, Validators.required),
      //   'NationalId': new FormControl(null)
      // })])
      ListPhone: this.fb.array([])
    });
    if (this.data && this.data.ListPhone && this.data.ListPhone.length > 0) {
      this.initFormArray(this.data.ListPhone);
    } else {
      this.newForm();
    }


  }
  newForm() {
    const creds = this.CompanyForm.controls.ListPhone as FormArray;
    creds.push(
      this.fb.group({
        GuidId: new FormControl(""),
        PhoneNumber: new FormControl(
          null,
          Validators.compose([
            Validators.maxLength(11),
          ])
        ),
        PhoneType: new FormControl(null, Validators.required)
      })
    );
  }

  editForm(list): FormGroup {
    let formGroup: FormGroup = new FormGroup({
      GuidId: new FormControl(list["GuidId"] ? list["GuidId"] : null),
      PhoneNumber: new FormControl(
        list["PhoneNumber"] ? list["PhoneNumber"] : null,
        Validators.maxLength(11)
      ),
      PhoneType: new FormControl(
        list["PhoneType"] ? list["PhoneType"].toString() : null,
        Validators.required
      )
    });
    return formGroup;
  }

  initFormArray(adresse) {
    if (adresse) {
      const formArray = this.CompanyForm.get("ListPhone") as FormArray;
      adresse.map(item => {
        formArray.push(this.editForm(item));
      });
      this.CompanyForm.setControl("ListPhone", formArray);
    }
  }

  init() {
    this.loadProvience();
    this.loadPhoneType();
    if (this.data && this.data["ProvinceId"]) {
      this.cityService.GetList(this.data["ProvinceId"]).subscribe(r => {
        this.cityList = r;

        if (this.data && this.data["CityId"]) {
          this.areaService.list(this.data["CityId"]).subscribe(e => {
            this.areaList = e;
          });
        }
      });
    }

    if (this.data && this.data["AddressDto"] && this.data["AddressDto"]["CityId"]) {
      this.areaService.list(this.data["AddressDto"]["CityId"]).subscribe(
        res => {
          this.areaList = res;
        },
        () => {
          this.errorService.transactionError();
        }
      );
    }
  }

  loadProvience() {
    this.provinceService.GetList().subscribe(
      res => {
        this.provinceList = res;
      },
      () => {
        this.errorService.transactionError();
      }
    );
  }

  loadCity(element: MatSelect) {
    this.cityService.GetList(element.value).subscribe(
      res => {
        this.cityList = res;
      },
      () => {
        this.errorService.transactionError();
      }
    );
  }
  loadArea(element: MatSelect) {
    this.areaService.list(element.value).subscribe(
      res => {
        this.areaList = res;
      },
      () => {
        this.errorService.transactionError();
      }
    );
  }

  loadPhoneType() {
    this.phoneTypeService.list().subscribe(
      res => {
        this.phoneTypeList = res;
      },
      () => {
        this.errorService.transactionError();
      }
    );
  }

  addPhone(): void {
    (<FormArray>this.CompanyForm.get("ListPhone")).push(
      new FormGroup({
        GuidId: new FormControl(""),
        PhoneNumber: new FormControl(
          null,
          Validators.compose([Validators.required, Validators.maxLength(11)])
        ),
        PhoneType: new FormControl(null)
      })
    );
  }
  removePhone(index: number) {
    if (index > 0)
      (<FormArray>this.CompanyForm.get("ListPhone")).removeAt(index);
  }

  addManager(): void {
    (<FormArray>this.CompanyForm.get("ListManager")).push(
      new FormGroup({
        GuidId: new FormControl(""),
        FirsName: new FormControl(null, Validators.required),
        LastName: new FormControl(null, Validators.required),
        NationalId: new FormControl(null, Validators.required)
      })
    );
  }
  removeManager(index: number) {
    if (index > 0)
      (<FormArray>this.CompanyForm.get("ListManager")).removeAt(index);
  }

  submit(form: ICompany) {
    this.errors = new Array();
    if (this.data && this.data.CompanyEncryptId) {
      this.companyService.edit(form).subscribe(
        () => {
          this.snackBar.OpenSnackBar(
            this.translate.get("success.registration"),
            "ok",
            5000,
            SoundEnum.beep
          );
          this.dialogRef.close();
        },
        error => {
          // this.errObject = this.errorService.getError(error);
          // this.param = this.errorService.objectError(this.errObject);
          // this.errors = this.errorService.returnError(error);
          this.errorList = this.errorService.getErrorList(error.error);
        }
      );
    } else {
      this.companyService.add(form).subscribe(
        () => {
          this.snackBar.OpenSnackBar(
            this.translate.get("success.registration"),
            "ok",
            5000,
            SoundEnum.beep
          );
          this.dialogRef.close();
        },
        error => {
          // this.errObject = this.errorService.getError(error);
          // this.param = this.errorService.objectError(this.errObject);
          // this.errors = this.errorService.returnError(error);
          this.errorList = this.errorService.getErrorList(error.error);
        }
      );
    }
  }

  onNoClick() {
    this.dialogRef.close();
  }
}
